import React from 'react';
import EmptyState from '../components/EmptyState';

const BookmarkIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
  </svg>
);

const BookingView: React.FC = () => (
  <EmptyState label="Bookings" icon={<BookmarkIcon />} />
);

export default BookingView;
